import { convertOrderDetail } from "./convertOrderDetail"

export const convertOrderDetailExpand = (data: any) => {
  return {
    requestOrder: convertOrderDetail(data.requestOrder),
    requestOrderExpand: data.requestOrderExpand
  }
}